import React from 'react'
import {
  loadByIdExerciseAction,
  updateCurrentWorkoutAction
} from '@gymaholic/packages'
import loadByIdWorkoutAction from 'modules/workout/redux/actions/load-by-id'

export const useExerciseMount = ({
  exercise,
  exerciseId,
  isReadOnly,
  currentWorkout,
  location,
  dispatch
}) => {
  React.useEffect(() => {
    if (!exercise) {
      dispatch(loadByIdExerciseAction(exerciseId))
    }

    if (
      !isReadOnly &&
      !currentWorkout &&
      location.state
    ) {
      dispatch(
        loadByIdWorkoutAction({
          id: location.state.originMatch.params.id
        })
      )

      dispatch(
        updateCurrentWorkoutAction(
          Number(location.state.originMatch.params.id)
        )
      )
    }
  }, [])
}
